class WholesalePurchasing {
  constructor() {
    this.dialog = document.querySelector('[data-wholesale-dialog]');
    if (!this.dialog) return;
    document.querySelectorAll('[data-wholesale-options]').forEach((button) => button.addEventListener('click', () => this.open(button)));
    this.dialog.querySelector('[data-wholesale-dialog-close]')?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
  }

  open(button) {
    const name = button.dataset.productName;
    const key = button.dataset.productKey;
    const faireUrl = button.dataset.faireUrl;
    this.dialog.querySelector('[data-wholesale-dialog-title]').textContent = name;
    const apply = this.dialog.querySelector('[data-wholesale-apply]');
    const baseApplyUrl = apply.href.split('?')[0];
    apply.href = `${baseApplyUrl}?product=${encodeURIComponent(key)}`;

    const faire = this.dialog.querySelector('[data-wholesale-faire]');
    const fairePending = this.dialog.querySelector('[data-wholesale-faire-pending]');
    faire.hidden = !faireUrl;
    fairePending.hidden = Boolean(faireUrl);
    if (faireUrl) faire.href = faireUrl;

    const distributorOption = this.dialog.querySelector('[data-wholesale-distributors]');
    const distributors = (button.dataset.distributors || '').split(',').filter(Boolean);
    distributorOption.hidden = distributors.length === 0;
    distributorOption.querySelector('[data-distributor-carmela]').hidden = !distributors.includes('carmela');
    distributorOption.querySelector('details').open = false;

    this.dialog.showModal();
  }
}

new WholesalePurchasing();
